// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"767fecb4","134":"934c250b","301":"7794b13f","453":"258b012d","500":"144db7dc","571":"93f22de7","793":"bfff3750","819":"9382e087"}[chunkId] + ".chunk.js";
};